/**
 * Detects an iOS home-screen (Add to Home Screen) install running in
 * `display-mode: standalone`.
 *
 * File downloads are impossible in that context — there is no Safari
 * chrome and no download manager to catch the response — so callers use
 * this to route the download control around it (#733).
 */
export function isStandaloneDisplay(): boolean {
  if (typeof window === "undefined") {
    return false;
  }
  const matchesDisplayMode = typeof window.matchMedia === "function"
    && window.matchMedia("(display-mode: standalone)").matches === true;
  const iosStandaloneFlag = (window.navigator as Navigator & { standalone?: boolean }).standalone === true;
  return matchesDisplayMode || iosStandaloneFlag;
}
